import ApiService from '../../../../shared/services/api-service';
import commonActions from '../../../../shared/store/common/action-creators';
import phonesActionsCreators from '../../phones/action-creators';
import myDepartmentActionCreators from './my-department';
import notificationsActionsCreator from '../../notifications/action-creators';

const myDepartmentPhonesActionsCreators = {
  updateMyDepartmentPhones(formData) {
    const patchData = {
      data: formData.phones,
      patched: 'phones',
    };
    return async (dispatch) => {
      dispatch(this.setIsLoading('updateMyDepartmentPhones'));
      const data = await ApiService.patch('/api/v1/my-department', patchData)
        .then(response => response.data)
        .catch(error => ({ error }));
      dispatch(this.setIsLoading('updateMyDepartmentPhones'));
      if (data.error) {
        dispatch(commonActions.handleApiError(data.error));
      } else {
        dispatch(this.updateMyDepartmentPhonesSuccess(data));
      }
    };
  },
  updateMyDepartmentPhonesSuccess(updated) {
    return (dispatch) => {
      dispatch(myDepartmentActionCreators.replaceMyDepartment(updated.data));
      // This action handles success for both add and edit, so make sure we dispatch
      //   to reset both related state keys
      dispatch(phonesActionsCreators.resetPhoneState());
      dispatch(notificationsActionsCreator.addSavedSuccessfully('Phones updated'))
    };
  },
};

export default myDepartmentPhonesActionsCreators;
